import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa } from '../shared/api-visa.model';
import { ApiResponseModel } from '../shared/api-response.model';
import { Observable } from 'rxjs';
import { EinvoiceBatchPoolToIrbLinkIncludingGenDocHdrContainerModel  } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_batch_pool_to_irb_link_including_gen_doc_hdr_container.model';
import {EinvoiceBatchPoolToIrbLinkContainerModel} from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_batch_pool_to_irb_link_container.model';
@Injectable({
  providedIn: 'root'
})
export class  EinvoiceBatchPoolToIrbLinkIncludingGenDocHdrService extends BaseApiTemplateService<EinvoiceBatchPoolToIrbLinkIncludingGenDocHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pol-to-irb-links/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pol-to-irb-links/batch-pool/gen-doc/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pol-to-irb-links/batch-pool/gen-doc/backoffice-ep'
    this.httpClient = http;
  }

  createBatchPoolIncludingGenDoc(dto: EinvoiceBatchPoolToIrbLinkContainerModel, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "e-invoice/batch-pol-to-irb-links/batch-pool/gen-doc/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dto,
      this.getHttpHeader(visa))
  }

  getBatchPoolWithGenDocByCriteria(criteria: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/batch-pol-to-irb-links/batch-pool/gen-doc/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      criteria,
      this.getHttpHeader(visa)
    );
  }

}
